import React from 'react';

export interface PercentageBarProps {
  percentage: number;
  attempt: number;
}

const PercentageBar = (props: PercentageBarProps) => {
  // if below 0 make it 0. if above 100 make it 100. if between 0 and 100, make it that number
  const percentage = Math.min(Math.max(props.percentage, 0), 100);

  return (
    <>
      <div className="flex gap-2">
        <div
          className={
            'w-full relative h-2 inline-block bg-neutral-periwinkle rounded-2xl'
          }
        >
          <div
            className={'absolute top-0 left-0 h-2 bg-primary-azure rounded-2xl'}
            style={{ width: `${percentage}%` }}
            data-testid={'percentage-inner'}
          />
        </div>
        <div className="inline-block mt-[-5px] text-right font-bold text-xs from-neutral-chalk float-right">
          &nbsp;{percentage}%
        </div>
      </div>
    </>
  );
};

export default PercentageBar;
